
import { useContext, createContext } from 'react';
import type { AnalyticsPort } from '@genieartinc/core-ports';

export const AnalyticsContext = createContext<AnalyticsPort | null>(null);

/**
 * Hook to access analytics adapter (PostHog)
 * Returns no-op implementation if analytics not initialized (graceful degradation)
 */
export function useAnalytics(): AnalyticsPort {
  const analytics = useContext(AnalyticsContext);

  if (!analytics) {
    // Graceful degradation - no-op analytics
    return {
      initialize: async () => {},
      identify: async () => {},
      track: async () => {},
      pageView: async () => {},
      setUserProperties: async () => {},
      incrementUserProperty: async () => {},
      captureException: async () => {},
      getFeatureFlags: async () => ({}),
      isFeatureFlagEnabled: async () => false,
      group: async () => {},
      alias: async () => {},
      reset: async () => {},
      optOut: async () => {},
      flush: async () => {},
      shutdown: async () => {},
    };
  }

  return analytics;
}
